import React from 'react'
import ArrowDown from 'component/ArrowDown'
import ArrowUp from 'component/ArrowUp'
import PropTypes from 'prop-types'

const Arrow = ({value = '0', fontSize, lineHeight}) => {

  const parseTend = parseFloat(value,10)
  value = value.replace('.', ',')
  const arrow = parseTend > 0
  ? <ArrowUp value={value} fontSize={fontSize} lineHeight={lineHeight} />
  : <ArrowDown value={value} fontSize={fontSize} lineHeight={lineHeight} />
  return  <div key={value}> {arrow} </div>

}

Arrow.propTypes = {
  fontSize: PropTypes.string,
  value: PropTypes.string,
  lineHeight: PropTypes.number

}



export default Arrow
